module.exports = __webpack_public_path__ + "img/4.3c2a33bc.png";